import Button from '@shared/components/core/button/CoreButton';
import DeleteIconButton from '@shared/components/core/button/DeleteIconButton';
import HeaderCreateButton from '@shared/components/core/button/HeaderCreateButton';
import HorizontalFieldContainer from '@shared/components/core/field/HorizontalFieldContainer';
import { StickyFooter } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import DictationControlField from '@shared/components/input/field/DictationControlField';
import UnsavedChangesDialog from '@shared/components/loading/UnsavedChangesDialog';
import EditProfileContainer from '@shared/hooks/state/EditProfileContainer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export default function ProfileDictationPageContent() {
    const { t } = useTranslation();
    const { organizationId } = useParams();
    const editProfileContainer = EditProfileContainer.useContainer();
    const [dictationCommands, setDictationCommands] = useState<string[]>(editProfileContainer.dictationCommands || []);

    useEffect(() => {
        if (editProfileContainer.dictationCommands) {
            setDictationCommands([...editProfileContainer.dictationCommands]);
        }
    }, [editProfileContainer.dictationCommands]);

    const handleCommandChange = (value: string, index: number) => {
        dictationCommands[index] = value;
        setDictationCommands([...dictationCommands]);
        editProfileContainer.setHasChanges(true);
    };
    const handleRemoveDictationCommand = (index: number) => {
        dictationCommands.splice(index, 1);
        setDictationCommands([...dictationCommands]);
        editProfileContainer.setHasChanges(true);
    };
    const handleAddDictationCommand = () => {
        dictationCommands.unshift('');
        setDictationCommands([...dictationCommands]);
        editProfileContainer.setHasChanges(true);
    };

    const handleSave = async () => {
        const filteredCommands = dictationCommands.filter((command) => command.length > 0);
        editProfileContainer.updateDictationCommands(filteredCommands);
        if (organizationId) {
            editProfileContainer.organizationIdRef.current = organizationId;
        }
        await editProfileContainer.saveChanges();
    };
    return (
        <>
            <HeaderCreateButton onClick={() => handleAddDictationCommand()} label={t('common:dictation.add')} />

            {dictationCommands?.map((h, i) => (
                <HorizontalFieldContainer key={i}>
                    <DictationControlField
                        value={h}
                        onChange={(e) => handleCommandChange(e, i)}
                        disabled={editProfileContainer.isPreview}
                    />
                    <DeleteIconButton
                        disabled={editProfileContainer.isPreview}
                        onClick={() => handleRemoveDictationCommand(i)}>
                        {t('common:dictation.remove')}
                    </DeleteIconButton>
                </HorizontalFieldContainer>
            ))}

            {editProfileContainer.hasChanges && (
                <UnsavedChangesDialog
                    hasChanges={editProfileContainer.hasChanges}
                    setHasChanges={editProfileContainer.setHasChanges}
                    onSave={handleSave}
                />
            )}
            <StickyFooter
                contentPosition="center"
                $visuallyHide={!editProfileContainer.hasChanges && editProfileContainer.id !== undefined}>
                <Button $color="primary" $size="large" startIcon="save" onClick={handleSave}>
                    {t('common:saveAndFinish')}
                </Button>
            </StickyFooter>
        </>
    );
}
